import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const loadLocaleMessages = () => {
  let locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  let messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

const localMessages = loadLocaleMessages()

const checkDefaultLanguage = () => {
  let locale = retrieveLocale()
  if (locale == null) {
    return null
  }
  let languages = Object.getOwnPropertyNames(localMessages)
  return languages.includes(locale) ? locale : null
}

const retrieveLocale = () =>
  // try loading from localstorage
  localStorage.getItem('locale') ||
  // try parsing from navigator locale
  navigator.language.split('-')[0]

export default new VueI18n({
  locale: checkDefaultLanguage() || process.env.VUE_APP_I18N_LOCALE || 'en',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  messages: localMessages
})
